export const MAKE_TABLE_VISIBLE_TIMEOUT = 100;
export const UPDATE_DIMENSIONS_DEFAULT_TIMEOUT = 10;
